import { render, staticRenderFns } from "./moovly.vue?vue&type=template&id=5eea393a&"
import script from "./moovly.vue?vue&type=script&lang=js&"
export * from "./moovly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports